import React, {PropTypes as T} from "react";
import classnames from 'classnames';
import {Container} from "react-responsive-grid";
import {rhythm} from "../utils/typography";
import Header from '../layouts/Header';
import SignupButton from './SignupButton';
import Button from './Button';
import Logo from '../logo.png';
import MailchimpScripts from './MailchimpScripts';
import './HeroSlide.css';


export default class HeroSlide extends React.Component {
  static propTypes = {
    hideLogo: T.bool,
    title: T.any,
    subtitle: T.any
  };

  render() {
    return (
      <div className="IndexPage-HeroBg"><Container
        style={{
          maxWidth: rhythm(35),
          padding: `${rhythm(0.5)} ${rhythm(3 / 4)} ${rhythm(1)}`,
        }}
      >
        <MailchimpScripts ref="mailchimp" />
        <Header
          showLogo={!this.props.hideLogo}
          selectedPlatform={this.props.selectedPlatform}
        />

        <div className={classnames(
          'IndexPage-Hero',
          this.props.bold ? 'HeroSlide--bold' : false
        )}>
          <h2>{this.props.title}</h2>
          <h4>{this.props.subtitle}</h4>
        </div>

        <div style={{
          marginBottom: '50px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <SignupButton />
          <Button
            secondary
            onClick={this.showMailingListPopUp}
            style={{marginLeft: '20px'}}
          >
            Subscribe to mailinglist
          </Button>
        </div>
      </Container></div>);
  }

  showMailingListPopUp = () => {
    this.refs.mailchimp.open();
  };
}


// WEBPACK FOOTER //
// ./src/components/HeroSlide.js